import { render, staticRenderFns } from "./chooseResourceStaff.vue?vue&type=template&id=995d3206&scoped=true"
import script from "./chooseResourceStaff.vue?vue&type=script&lang=js"
export * from "./chooseResourceStaff.vue?vue&type=script&lang=js"
import style0 from "./chooseResourceStaff.vue?vue&type=style&index=0&id=995d3206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995d3206",
  null
  
)

export default component.exports